export default __webpack_public_path__ + "static/media/i02.f53544f9.png";